import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faHand } from '@fortawesome/pro-regular-svg-icons';
import { useGlobalCtx } from '../../../Context/GlobalContext';

interface SessionStandbyProps{
  id:string
}
export default function SessionStandby(props:SessionStandbyProps) {

    const globalCtx = useGlobalCtx()
  return (
        <div id={props.id} className="theme-session-standby flex w-full">
          <FontAwesomeIcon className="theme-session-standby-icon mt-[3px] theme-icon-spacer" icon={faHand}/>
          <div className="theme-session-standby-text text-sm font-semibold">{globalCtx.LangResources.recruitMsg.standByMsg}</div>
        </div>
  )
}
